import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { ApplicationContextService } from '../../../../../../shared/services/application-context.service';
import { ApplicationConfigService } from '../../../../../../shared/services/application-config.service';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-sensorManagement',
  templateUrl: './sensor.component.html',
  styleUrls: ['./sensor.component.css'],
})
export class SensorManagementComponent implements OnInit {
  // Application context
  selectedApplicationId: number | null = null;
  availableSensorTypes: ('storage' | 'transport')[] = [];

  constructor(
    private applicationContextService: ApplicationContextService,
    private applicationConfigService: ApplicationConfigService
  ) {}

  ngOnInit() {
    this.subscribeToApplicationContext();
  }

  private subscribeToApplicationContext() {
    this.applicationContextService.selectedApplicationId$
      .pipe(untilDestroyed(this))
      .subscribe((applicationId) => {
        this.selectedApplicationId = applicationId;
        this.updateAvailableSensorTypes();
      });
  }

  private updateAvailableSensorTypes() {
    if (!this.selectedApplicationId) {
      this.availableSensorTypes = ['storage', 'transport'];
      return;
    }

    switch (this.selectedApplicationId) {
      case 1: 
        this.availableSensorTypes = ['storage'];
        break;
      case 2: 
        this.availableSensorTypes = ['transport'];
        break;
      default:
        this.availableSensorTypes = ['storage', 'transport'];
    }
  }

  getApplicationName(): string {
    if (!this.selectedApplicationId) {
      return 'All Applications';
    }
    const config = this.applicationConfigService.getApplicationConfig(
      this.selectedApplicationId
    );
    return config ? config.name : 'Unknown Application';
  }
}
